import React, { useEffect, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import styled from '@emotion/styled';
import { COLLECTION_FILTERS_TRANSLATE } from '../../../../config';
import Button from '../../../common/Button';

const BoxWrapper = styled('div')`
  margin-bottom: 0;
  padding-bottom: 60px;
  .submit-button {
    margin: 0 auto;
    width: 100%;
    position: absolute;
    bottom: -46px;
  }

  .filters-row {
    position: relative;
  }
`;

const CardWrapper = styled('div')`
  margin-top: 10px;
  width: 100%;
  .dd-handle {
    display: flex;
    align-items: center;
    font-weight: normal !important;
    .custom-control {
      display: flex;
      align-items: center;
      margin-left: 10px;
    }
    &:hover {
      color: #333 !important;
    }
    .separator-item {
      margin-left: 10px;
      font-weight: 500;
    }
  }

  .filter-toggler {
    &:hover {
      cursor: pointer;
    }
  }
`;

const CollectionFilters = (props) => {
  const { collectionFilters, editAllCollectionFilters } = props;

  const [cards, setCards] = useState([]);
  const [draggedCardId, setDraggedCardId] = useState(null);
  const [displaySaveButton, setDisplaySaveButton] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const getFormattedCollections = (data) => {
    if (!data || !data.length) return null;

    const formattedData = data.reduce((a, c, i) => {
      if (c.filters) {
        c.filters
          .sort((a, b) => {
            if (a.ordering > b.ordering) return 1;
            if (a.ordering < b.ordering) return -1;
            return 0;
          })
          .forEach((f) => {
            a.push({
              ...f,
              blockId: c.id,
            });
          });
      }

      if (i + 1 < data.length) {
        a.push({
          type: 'separator',
          id: uuidv4(),
          blockId: c.id,
        });
      }
      return a;
    }, []);

    const dataForCardsWithId = formattedData.map((data, idx) => {
      return {
        ...data,
        cardId: idx,
      };
    });

    return dataForCardsWithId;
  };

  useEffect(() => {
    const formattedCollections = getFormattedCollections(collectionFilters);
    setCards(formattedCollections);
  }, [collectionFilters]);

  const handleDragStart = (event, id) => {
    event.dataTransfer.setData('text/plain', id);
    event.dataTransfer.effectAllowed = 'copyMove';
    setDraggedCardId(id);
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleDrop = (event, targetId) => {
    const draggedId = event.dataTransfer.getData('text/plain');
    if (draggedId !== targetId) {
      const draggedIndex = cards.findIndex((card) => card.cardId === parseInt(draggedId));
      const targetIndex = cards.findIndex((card) => card.cardId === targetId);

      const updatedCards = [...cards];
      const [draggedCard] = updatedCards.splice(draggedIndex, 1);
      updatedCards.splice(targetIndex, 0, draggedCard);

      setCards(updatedCards);
      setDisplaySaveButton(true);
    }
    setDraggedCardId(null);
  };

  const setOrdering = () => {
    let idxCounter = 0;

    for (let i = 0; i < cards.length; i++) {
      if (cards[i].type === 'separator') {
        idxCounter = 0;
      } else {
        cards[i].ordering = idxCounter;
        idxCounter++;
      }
    }

    return cards;
  };

  const toggleFilter = (value, index) => {
    setDisplaySaveButton(true);
    const updatedCards = [...cards];
    const isEnabled = !value;
    updatedCards[index].enabled = isEnabled;
    setCards(updatedCards);
  };

  const handleUpdateAllFilters = async () => {
    setIsLoading(true);

    const orderedCards = setOrdering();
    await editAllCollectionFilters(orderedCards);

    setIsLoading(false);
    setDisplaySaveButton(false);
  };

  return (
    <BoxWrapper className="card-box">
      <div className="row">
        <div className="col-12">
          <h4 className="header-title">Настройка фильтров коллекции</h4>
        </div>
      </div>
      <div className="row filters-row">
        <CardWrapper className="custom-dd dd">
          <ol className="dd-list">
            {cards?.length > 0 &&
              cards.map((card, index) => (
                <li
                  className="dd-item"
                  key={card.cardId}
                  draggable="true"
                  onDragStart={(e) => handleDragStart(e, card.cardId)}
                  onDragOver={handleDragOver}
                  onDrop={(e) => handleDrop(e, card.cardId)}
                  style={{
                    opacity: draggedCardId === card.cardId ? 0.5 : 1, // Опционально: уменьшить непрозрачность перетаскиваемой карточки
                  }}
                >
                  <div className="dd-handle">
                    <i className="fe-align-justify" />
                    {card.type !== 'separator' ? (
                      <div className="custom-control custom-switch filter-toggler">
                        <input
                          type="checkbox"
                          className="custom-control-input"
                          id={`collectionFilter-${card.type}-${index}`}
                          checked={card.enabled}
                          onChange={() => toggleFilter(card.enabled, index)}
                        />
                        <label
                          className="custom-control-label filter-toggler"
                          htmlFor={`collectionFilter-${card.type}-${index}`}
                        >
                          {(card.type === `ATTRIBUTES` || card.type === `FEATURES`) &&
                          card?.fields?.[0]?.title
                            ? `${card.type} (${card.fields[0].title})`
                            : COLLECTION_FILTERS_TRANSLATE[card.type] || card.type}
                        </label>
                      </div>
                    ) : (
                      <div className="separator-item filter-toggler">Разделитель</div>
                    )}
                  </div>
                </li>
              ))}
          </ol>
        </CardWrapper>
        {displaySaveButton ? (
          <Button
            className="submit-button"
            type="submit"
            text="Сохранить изменения"
            onClick={handleUpdateAllFilters}
            loading={isLoading}
          />
        ) : null}
      </div>
    </BoxWrapper>
  );
};

export default CollectionFilters;
